<template>
  <div class="slideshow-container" @mouseenter="startSlideshow" @mouseleave="stopSlideshow"
    :style="{ '--slide-height': `${height}px` }" @click="openProfile">
    <slot></slot>
    <div class="slides" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
      <div class="slide" v-for="(image, index) in images" :key="index">
        <img :src="`${$cloudFrontApi}${image}/GALLERY_IPHONE6`" :alt="'Slide ' + (index + 1)" />
      </div>
    </div>
    <div>
      <h5 class="text-left">{{ item != null ? item.name : '' }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: false
    },
    zahl: {
      type: Number,
    },
    height: {
      type: Number,
      default: 200
    },
    images: {
      type: Array,
      default: () => [
        'https://via.placeholder.com/600x300?text=Image+1',
        'https://via.placeholder.com/600x300?text=Image+2',
        'https://via.placeholder.com/600x300?text=Image+3',
        'https://via.placeholder.com/600x300?text=Image+4',
      ]
    }

  },

  data() {
    return {
      currentSlide: 0,
      // images: [
      //   'https://via.placeholder.com/600x300?text=Image+1',
      //   'https://via.placeholder.com/600x300?text=Image+2',
      //   'https://via.placeholder.com/600x300?text=Image+3',
      //   'https://via.placeholder.com/600x300?text=Image+4',
      // ],
      slideInterval: null,
    };
  },
  methods: {
    startSlideshow() {
      this.nextSlide();
      if (!this.slideInterval) {
        this.slideInterval = setInterval(() => {
          this.nextSlide();
        }, 2000); // Change slide every 2 seconds (adjust as needed)
      }
    },
    stopSlideshow() {
      // Stop immediately when the mouse leaves
      if (this.slideInterval) {
        clearInterval(this.slideInterval);
        this.slideInterval = null;
      }
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.images.length;
    },
    openProfile() {
      this.$router.push(`/fairling/${this.item.id}/`)
    }
  },
};
</script>

<style scoped>
.slideshow-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.slides {
  display: flex;
  transition: transform 1s ease-in-out;
}

.slide {
  min-width: 100%;
  height: var(--slide-height, 200px);
  /* You can adjust this height or make it dynamic */
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

h5 {
  font-size: 12pt;
}
</style>